import {useMediaQuery} from 'react-responsive';

export enum Spacing {
  AUTO = 'auto',
  ZERO = '0',
  ZERO_125 = '0.125rem',
  ZERO_25 = '0.25rem',
  ZERO_3125 = '0.3125rem',
  ZERO_375 = '0.375rem',
  ZERO_5 = '0.5rem',
  ZERO_625 = '0.625rem',
  ZERO_75 = '0.75rem',
  ZERO_875 = '0.875rem',
  ONE = '1rem',
  ONE_125 = '1.125rem',
  ONE_2 = '1.2rem',
  ONE_25 = '1.25rem',
  ONE_3125 = '1.3125rem',
  ONE_375 = '1.375rem',
  ONE_4375 = '1.4375rem',
  ONE_5 = '1.5rem',
  ONE_65 = '1.65rem',
  ONE_75 = '1.75rem',
  ONE_875 = '1.875rem',
  TWO = '2rem',
  TWO_375 = '2.375rem',
  TWO_5 = '2.5rem',
  TWO_625 = '2.625rem',
  TWO_75 = '2.75rem',
  THREE = '3rem',
  THREE_125 = '3.125rem',
  THREE_5 = '3.5rem',
  THREE_75 = '3.75rem',
  FOUR = '4rem',
  FOUR_5 = '4.5rem',
  FIVE = '5rem',
  SIX = '6rem',
  EIGHT = '8rem',
  TEN_125 = '10.125rem',
  TEN_5 = '10.5rem',
  NINETEEN = '19rem'
}

export enum Display {
  BLOCK = 'block',
  FLEX = 'flex',
  INLINE = 'inline',
  INLINE_BLOCK = 'inline-block'
}

export enum Breakpoints {
  DESKTOP = 'max-width: 70em',
  DESKTOP_COLUMNS_RESIZED = 'max-width: 63em',
  TABLET = 'max-width: 48em',
  NOT_TABLET = 'min-width: 48.01em',
  MOBILE = 'max-width: 37.5em',
  NOT_MOBILE = 'min-width: 37.51em'
}

export enum BreakpointPixels {
  NOT_TABLET = 769
}

export const useIsDesktopResolutionWithResizedLayoutColumns = () => {
  const isPrimaryColumnResized = useMediaQuery({query: `(${Breakpoints.DESKTOP_COLUMNS_RESIZED})`});
  const isTabletScreen = useMediaQuery({query: `(${Breakpoints.TABLET})`});
  return isPrimaryColumnResized && !isTabletScreen;
};

export const QUOTING_CARDS_BREAK = 'max-width: 56em';
export const NOT_QUOTING_CARDS_BREAK = 'min-width: 56.01em';
export const QUOTING_CARDS_WRAP_BREAK = 'max-width: 74em';
export const DESKTOP_TO_TABLET_BREAK = 'max-width: 65.5em';
export const LIFE_QUOTE_HEADER_BREAK = 'max-width: 59em';

export const DESKTOP_HEADER_BREAK = 'max-width: 72em';

export enum ZIndex {
  ZERO = 0,
  FLOATING_BUTTON = 10,
  DAY_PICKER = 10,
  SKIP_LINK = 40,
  QUOTE_GROUP = 45,
  STICKY_ELEMENT = 50,
  SECONDARY_STICKEY_ELEMENT = 55,
  TOOLTIP_OVERLAY = 60,
  ERROR_OVERLAY = 70,
  MODAL = 80,
  DROPDOWN = 90,
  SESSION_TIMEOUT_MODAL = 100,
  FEEDBACK_BADGE = 10000,
  CHAT_BOT = 999999999
}

export enum FontSize {
  ZERO_8125 = '.8125rem',
  ZERO_813 = '.813rem',
  ZERO_875 = '.875rem',
  ZERO_95 = '.95rem',
  ONE = '1rem',
  ONE_125 = '1.125rem',
  ONE_25 = '1.25rem',
  ONE_5 = '1.5rem',
  TWO = '2rem',
  TWO_375 = '2.375rem',
  TWO_625 = '2.625rem',
  THREE = '3rem'
}

export enum FontWeight {
  LIGHT = 300,
  REGULAR = 400,
  MEDIUM = 500,
  SEMI_BOLD = 600,
  BOLD = 700,
  SUPER_BOLD = 900
}

export enum FontFamily {
  ARIAL_MT = 'ArialMT, Arial, sans-serif',
  AVENIR = 'Avenir, Arial, sans-serif',
  AVENIR_BOLD = 'AvenirBold, Arial, sans-serif',
  AVENIR_LIGHT = 'AvenirLight, Arial, sans-serif',
  AVENIR_MEDIUM = 'AvenirMedium, Arial, sans-serif',
  RHYMES_MEDIUM = 'RhymesMedium, Times New Roman, serif',
  DEFAULT = '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Arial, sans-serif'
}
export enum BorderRadius {
  ZERO_PX = '0px',
  THREE_PX = '3px',
  FIVE_PX = '5px',
  EIGHT_PX = '8px',
  SIXTEEN_PX = '16px'
}
export enum IconSize {
  PX_16 = '16',
  PX_20 = '20',
  PX_24 = '24',
  PX_25 = '25',
  PX_32 = '32',
  PX_40 = '40',
  PX_45 = '45',
  PX_48 = '48',
  PX_56 = '56',
  PX_66 = '66'
}
